import React, { Fragment, useContext, useEffect } from "react";
import AuthContext from "../../context/auth/authContext";
import UserContext from "../../context/user/userContext";
import alt from "../layouts/default.png";
import { Link } from "react-router-dom";
import "../../styles/fonts.css";
import "../../styles/index.css";
const AccountHome = (props) => {
  const authContext = useContext(AuthContext);
  const userContext = useContext(UserContext);
  const { user, videos, notes } = userContext;
  useEffect(() => {
    window.scrollTo(0, 0);

    userContext.getUser(props.match.params.uid);
    userContext.getUserResources({
      id: props.match.params.uid,
    });
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div className=' position-relative bg-light p-2' style={{ top: "85px" }}>
        <div className='row my-2 '>
          <div className='col-lg-5 order-lg-1 text-center'>
            <img
              src={(user && user.photoURL) || alt}
              className='mx-auto img-fluid img-circle d-block'
              alt='avatar'
            />
            <h3 className='m-2 titlefont'>{user && user.displayName}</h3>
          </div>
          <div className='col-lg-7 order-lg-2'>
            <h4 className='mb-3 text-center size09 fontcool'>User Profile</h4>
            <div className='row'>
              <div className='col-md-5 text-center'>
                <h5 className='size11 slantfont'>Bio</h5>
                <p className='simplefont'>{user && user.bio}</p>
              </div>
              <div className='col-md-7'>
                <div className='my-4  d-flex flex-column align-items-lg-end align-items-xl-end align-items-md-end'>
                  <span
                    className='badge badge-danger d-block m-2 size11 fontcool'
                    style={{ width: "10em" }}
                  >
                    {user &&
                      "+91 " +
                        user.mobno.substring(0, 5) +
                        " " +
                        user.mobno.substring(5)}
                  </span>
                  <span
                    className='badge badge-warning d-block m-1 size11 fontcool'
                    style={{ width: "14em" }}
                  >
                    {user && user.email}
                  </span>
                </div>
                <div className='d-flex flex-column align-items-lg-end align-items-xl-end align-items-md-end'>
                  {videos && (
                    <span
                      className='badge badge-primary d-block m-2 size11 slantfont'
                      style={{ width: "8em" }}
                    >
                      <i className='fa fa-user'></i> {videos.length} Videos
                    </span>
                  )}
                  <span
                    className='badge badge-success d-block m-2 size11 slantfont'
                    style={{ width: "8em" }}
                  >
                    <i className='fa fa-cog'></i> {notes && notes.length} Notes
                  </span>
                </div>
              </div>
              {/*<span className='badge badge-danger'>
                  <i className='fa fa-eye'></i> 3 Playlists
                </span>
              </div>
              <div className='col-md-12'>
                <h5 className='mt-2'>
                  <span className='fa fa-clock-o ion-clock float-right'></span>{" "}
                  Preferred Courses
                </h5>
                <table className='table table-sm table-hover table-striped'>
                  <tbody>
                    <tr>
                      <td>MA 105</td>
                    </tr>
                    <tr>
                      <td>CH 103</td>
                    </tr>
                    <tr>
                      <td>IC 153</td>
                    </tr>
                    <tr>
                      <td>PH 105</td>
                    </tr>
                    <tr>
                      <td>CS 103</td>
                    </tr>
                  </tbody>
                </table>
                  </div>*/}
            </div>
          </div>
        </div>

        <div className='p-2'>
          <h6 className='text-center size09 fontcool'>Skills</h6>
          <hr />
          <div className='d-flex justify-content-around row'>
            {user &&
              user.skills &&
              user.skills.map((item) => (
                <span
                  className='badge badge-dark badge-pill size11 fontcool '
                  key={item}
                >
                  {item}
                </span>
              ))}
          </div>
        </div>

        {authContext.currentUser &&
          props.match.params.uid === authContext.currentUser.uid && (
            <Link to='/editaccount'>
              <button className='btn btn-block btn-outline-dark my-4 slantfont size11'>
                Edit
              </button>
            </Link>
          )}
      </div>
    </Fragment>
  );
};

export default AccountHome;
